import { render, staticRenderFns } from "./ItemCardSquareSlider.vue?vue&type=template&id=41f8e22c&"
import script from "./ItemCardSquareSlider.vue?vue&type=script&lang=js&"
export * from "./ItemCardSquareSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports